'use client';

import { Suspense, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useSession } from 'next-auth/react';

import { useBreadcrumbs } from '~/entities';
import { KeywordPerformanceAnalysis } from '~/entities/KeywordPerformance';
import { ContentTitle } from '~/shared';
import roles from '~/types/constants/roles';

function DesempenhoContent() {
  return <KeywordPerformanceAnalysis />;
}

export function DesempenhoPalavrasChavesView() {
  const breadcrumbs = useBreadcrumbs();
  const router = useRouter();
  const { data: session } = useSession();
  const role = session?.user?.role;
  const hasManufacturerId = !!session?.user?.manufacturerId;
  const isManufacturerRole =
    role === roles[3] ||
    session?.user?.projects?.some(p => p.roleName === roles[3]);

  useEffect(() => {
    if (isManufacturerRole || hasManufacturerId) {
      router.replace('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isManufacturerRole, hasManufacturerId]);

  useEffect(() => {
    breadcrumbs.setPaths([
      {
        label: 'Desempenho',
        path: '/desempenho-palavras-chaves',
      },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ContentTitle title="Desempenho" />
      <Suspense>
        <DesempenhoContent />
      </Suspense>
    </>
  );
}
